/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit CaptureSignature.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/Caveat-400.js"
import Body from 'DesignSystem/Body/view.js'
import ButtonIcon from 'DesignSystem/ButtonIcon/view.js'
import Canvas from 'DesignSystem/Canvas/react.js'
import ImageCapture from 'DesignSystem/ImageCapture/logic.js'
import Input from 'DesignSystem/Input/logic.js'
import React from 'react'
import Reset from 'DesignSystem/Svgs/Reset/view.js'
import { css } from "emotion"
ImageCapture.displayName = 'ImageCaptureLogic'
Input.displayName = 'InputLogic'

let styles = {}
styles.SignatureContainer = css({label: 'SignatureContainer',
  alignItems: "center",
borderBottomLeftRadius: 4,
borderBottomRightRadius: 4,
borderColor: "lightgrey",
borderStyle: "solid",
borderTopLeftRadius: 4,
borderTopRightRadius: 4,
borderWidth: 1,
height: 200,
width: "100%",
justifyContent: "center",
marginTop: 15,
paddingBottom: 5,
paddingLeft: 20,
paddingRight: 20,
paddingTop: 5,
overflowX: "hidden"})
styles.TypeWrapper = css({label: 'TypeWrapper',
  alignItems: "center",
height: 100,
width: "100%",
justifyContent: "center"})
styles.UploadWrapper = css({label: 'UploadWrapper',
  alignItems: "center",
height: 10,
justifyContent: "center"})
styles.Choices = css({label: 'Choices',
  flexDirection: "row",
alignItems: "center"})

export default class CaptureSignature extends React.Component {
  render() {
    let { props: {
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  height= 190,
isSign,
canvas,
width= 600,
isWrite,
setName,
onSubmit,
dataWrite,
isUpload,
accept= ".jpg,.jpeg,.png,/image*",
signatureCaptureKey,
label= "Click here to upload your signature",
setUpload,
dataUpload,
clear,
isHovered
} } = this
    return (<React.Fragment
>
<div
 data-testid="CaptureSignature.CaptureSignature:1"
 data-view-path={dataViewPath}
 className="views-block"
>
<div
 data-testid="CaptureSignature.SignatureContainer"
 data-view-path={dataViewPath}
 className={`views-block ${styles.SignatureContainer}`}
>
<Canvas
 data-testid="CaptureSignature.Canvas"
 data-view-path={dataViewPath}
 height={height}
 isShown={isSign}
 line="none"
 ref={canvas}
 width={width}
/>
{
isWrite ? 
<div
 data-testid="CaptureSignature.TypeWrapper"
 data-view-path={dataViewPath}
 className={`views-block ${styles.TypeWrapper}`}
>
<Input
 data-testid="CaptureSignature.Input"
 data-view-path={dataViewPath}
 autoFocus={true}
 fontFamily="Caveat"
 fontSize={32}
 fontWeight={400}
 onChange={setName}
 onSubmit={onSubmit}
 placeholder="Type your name"
 type="text"
 value={dataWrite}
/>
</div>
 : null
}
{
isUpload ? 
<div
 data-testid="CaptureSignature.UploadWrapper"
 data-view-path={dataViewPath}
 className={`views-block ${styles.UploadWrapper}`}
>
<ImageCapture
 data-testid="CaptureSignature.ImageCapture"
 data-view-path={dataViewPath}
 accept={accept}
 key={signatureCaptureKey}
 label={label}
 onChange={setUpload}
 value={dataUpload}
 marginBottom={0}
 shadowBlur={0}
 shadowOffsetY={0}
 width={550}
/>
</div>
 : null
}
</div>
<div
 data-testid="CaptureSignature.Choices"
 data-view-path={dataViewPath}
 className={`views-block ${styles.Choices}`}
>
<ButtonIcon
 data-testid="CaptureSignature.ClearOption"
 data-view-path={dataViewPath}
 onClick={clear}
 paddingLeft={0}
 text="Clear"
 marginRight="auto"
>
{childProps => (
<Reset
{...childProps}
 data-testid="CaptureSignature.Reset"
 data-view-path={dataViewPath}
 height={18}
 stroke={childProps.isHovered ? "rgba(0, 188, 112, 0.83)" : "#323232"}
 width={18}
/>
)}
</ButtonIcon>
{
isSign ? 
<Body
 data-testid="CaptureSignature.Body"
 data-view-path={dataViewPath}
 alignSelf="flex-end"
 marginTop={2}
 fontSize={12}
 text="Use your mouse to sign your name in the box above"
/>
 : null
}
</div>
</div>
{children}
</React.Fragment>)
  }
}